import { Component, OnDestroy, inject } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { Interval } from 'app/types';

import { SceneService } from '../../services/scene.service';

import { VideoRoomService } from './../../services/video-room.service';

const METRICS_INTERVAL_MS = 250;

@Component({
  selector: 'performance-debugger',
  templateUrl: './performance-debugger.component.html',
  styleUrls: ['./performance-debugger.component.scss'],
  standalone: false,
})
export class PerformanceDebuggerComponent implements OnDestroy {
  private sceneService = inject(SceneService);
  private videoRoomService = inject(VideoRoomService);

  private destroyed$ = new ReplaySubject<boolean>(1);
  private metricsInterval?: Interval;

  public fps = '0';
  public userCount = 0;
  public svcInterval = 10;
  public minFPSBadCondition = 15;
  public minFPSConditionFixed = 25;
  public connectionStatusBadCondition = 'poor';
  protected renderer = '';

  public constructor() {
    this.metricsInterval = setInterval(this.getMetrics.bind(this), METRICS_INTERVAL_MS);
    switch (this.sceneService.sceneManager?.app?.renderer.type) {
      case 1:
        this.renderer = 'WebGL';
        break;
      case 2:
        this.renderer = 'Canvas';
        break;
      default:
        this.renderer = 'Unknown';
        break;
    }
  }

  public ngOnDestroy(): void {
    if (this.metricsInterval) {
      clearInterval(this.metricsInterval);
    }
    this.metricsInterval = undefined;
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private getMetrics(): void {
    this.getFps();
    this.getUserCount();
  }

  private getFps(): void {
    this.fps = this.sceneService.fps.toFixed(2);
  }

  private getUserCount(): void {
    this.userCount = this.sceneService.getUserCount();
  }

  public setParams(): void {
    this.videoRoomService.setSVCParameters(this.connectionStatusBadCondition, this.svcInterval * 1000);
  }
}
